// Mock data for Koctech Klima website

export const products = [
  {
    id: 1,
    name: "Fuji Therma Eco 09K Inverter",
    category: "Fuji Therma Serisi",
    description: "Yeni nesil Fuji Therma inverter teknolojisi ile küçük odalar için ideal",
    image: "https://images.unsplash.com/photo-1759772238012-9d5ad59ae637?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxpbmRvb3IlMjBjb29saW5nfGVufDB8fHx8MTc2MzIwNzQ3M3ww&ixlib=rb-4.1.0&q=85",
    btu: 9000,
    energyClass: "A+++",
    features: ["Fuji Therma inverter", "Ultra sessiz", "WiFi kontrol", "Eco mod", "R32 gaz"]
  },
  {
    id: 2,
    name: "Fuji Therma Pro 12K Inverter",
    category: "Fuji Therma Serisi",
    description: "Orta boy odalar için profesyonel Fuji Therma çözümü",
    image: "https://images.unsplash.com/photo-1545259741-2ea3ebf61fa3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxhaXIlMjBjb25kaXRpb25pbmd8ZW58MHx8fHwxNzYzMjA3NDYxfDA&ixlib=rb-4.1.0&q=85",
    btu: 12000,
    energyClass: "A+++",
    features: ["Akıllı sensörler", "Turbo soğutma", "WiFi kontrol", "Gece modu", "Otonom temizlik"]
  },
  {
    id: 3,
    name: "Fuji Therma Ultra 18K Inverter",
    category: "Fuji Therma Serisi",
    description: "Geniş alanlar için güçlü Fuji Therma premium model",
    image: "https://images.unsplash.com/photo-1757219525975-03b5984bc6e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxIVkFDJTIwdW5pdHxlbnwwfHx8fDE3NjMyMDc0Njd8MA&ixlib=rb-4.1.0&q=85",
    btu: 18000,
    energyClass: "A+++",
    features: ["Premium inverter", "4 yönlü hava akışı", "Sessiz pro mod", "Akıllı WiFi", "Enerji tasarrufu max"]
  },
  {
    id: 7,
    name: "Koctech SilentCool 12K",
    category: "Koctech Özel Serisi",
    description: "Sessiz çalışma teknolojisi ile orta boy odalar için ideal",
    image: "https://images.unsplash.com/photo-1545259741-2ea3ebf61fa3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxhaXIlMjBjb25kaXRpb25pbmd8ZW58MHx8fHwxNzYzMjA3NDYxfDA&ixlib=rb-4.1.0&q=85",
    btu: 12000,
    energyClass: "A++",
    features: ["Ultra sessiz motor", "Eco mod", "Gece modu", "Uzaktan kontrol", "Akıllı sensörler"]
  },
  {
    id: 8,
    name: "Koctech ProVRF 18K",
    category: "Koctech Özel Serisi",
    description: "Geniş alanlar için profesyonel çözüm",
    image: "https://images.unsplash.com/photo-1757219525975-03b5984bc6e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxIVkFDJTIwdW5pdHxlbnwwfHx8fDE3NjMyMDc0Njd8MA&ixlib=rb-4.1.0&q=85",
    btu: 18000,
    energyClass: "A++",
    features: ["Profesyonel kapasite", "4 yönlü hava akışı", "WiFi kontrol", "Turbo mod", "Enerji tasarrufu"]
  },
  {
    id: 4,
    name: "VRF Multi Split Sistem",
    category: "VRF Sistemleri",
    description: "Çoklu iç ünite desteği ile ticari mekanlar için profesyonel çözüm",
    image: "https://images.pexels.com/photos/2539462/pexels-photo-2539462.jpeg",
    btu: "Değişken",
    energyClass: "A+++",
    features: ["Çoklu oda kontrolü", "Merkezi yönetim", "Düşük işletme maliyeti", "Yüksek verimlilik"]
  },
  {
    id: 5,
    name: "Ticari Tip VRF Sistem",
    category: "VRF Sistemleri",
    description: "Ofis binaları ve büyük ticari alanlar için endüstriyel çözüm",
    image: "https://images.unsplash.com/photo-1759646827242-cf09e30709aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxIVkFDJTIwdW5pdHxlbnwwfHx8fDE3NjMyMDc0Njd8MA&ixlib=rb-4.1.0&q=85",
    btu: "Değişken",
    energyClass: "A+++",
    features: ["Modüler yapı", "Uzaktan izleme", "Enerji geri kazanım", "Akıllı kontrol sistemi"]
  },
  {
    id: 6,
    name: "Kaset Tip Klima",
    category: "Ticari Klimalar",
    description: "Asma tavan montajı ile estetik ve etkili soğutma",
    image: "https://images.pexels.com/photos/2539462/pexels-photo-2539462.jpeg",
    btu: 24000,
    energyClass: "A++",
    features: ["360° hava dağılımı", "Görünmez tasarım", "Düşük ses seviyesi", "Kolay bakım"]
  }
];

export const services = [
  {
    id: 1,
    title: "Profesyonel Montaj",
    description: "Uzman ekibimiz ile güvenli ve kaliteli klima montajı hizmeti",
    icon: "Wrench",
    details: [
      "Ücretsiz keşif ve danışmanlık",
      "Profesyonel montaj ekibi",
      "Tüm klima türleri için hizmet",
      "Garanti belgesi"
    ]
  },
  {
    id: 2,
    title: "Teknik Servis",
    description: "7/24 acil servis ve arıza giderme hizmeti",
    icon: "Settings",
    details: [
      "Hızlı müdahale",
      "Orijinal yedek parça",
      "Deneyimli teknisyenler",
      "Uygun fiyatlandırma"
    ]
  },
  {
    id: 3,
    title: "Bakım ve Temizlik",
    description: "Düzenli bakım ile klimanızın ömrünü uzatın",
    icon: "Droplets",
    details: [
      "Periyodik bakım planları",
      "Derin temizlik hizmeti",
      "Gaz dolumu",
      "Filtre değişimi"
    ]
  },
  {
    id: 4,
    title: "VRF Sistem Kurulumu",
    description: "Ticari mekanlar için profesyonel VRF sistem çözümleri",
    icon: "Building2",
    details: [
      "Proje tasarımı",
      "Profesyonel kurulum",
      "Sistem entegrasyonu",
      "Kullanıcı eğitimi"
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Ahmet Yılmaz",
    role: "Ev Sahibi",
    comment: "Koctech Klima ile çalışmak harika bir deneyimdi. Montaj ekibi çok profesyonel ve işlerini titizlikle yaptılar. Klimalarımız mükemmel çalışıyor!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1761330440311-16e160cad236?w=100&h=100&fit=crop"
  },
  {
    id: 2,
    name: "Zeynep Kaya",
    role: "İşletme Sahibi",
    comment: "Ofisimiz için VRF sistem kurdurduk. Hem enerji tasarrufu sağladık hem de tüm çalışanlarımız memnun. Teşekkürler Koctech!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1761330439671-a7f20c285c5e?w=100&h=100&fit=crop"
  },
  {
    id: 3,
    name: "Mehmet Demir",
    role: "Restoran Sahibi",
    comment: "Servis hızınız ve çözüm odaklı yaklaşımınız için teşekkürler. Restoranımızdaki klima arızasını çok hızlı çözdünüz.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1761782791727-3994283faa88?w=100&h=100&fit=crop"
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Yusuf Karakoç",
    role: "Genel Müdür Yardımcısı",
    image: "https://customer-assets.emergentagent.com/job_klima-experts/artifacts/jkaeqn48_yusuf3.png",
    bio: "Profesyonel yönetim ve müşteri memnuniyeti odaklı hizmet"
  },
  {
    id: 2,
    name: "Teknik Ekip",
    role: "Uzman Teknisyenler",
    image: "https://images.pexels.com/photos/5463581/pexels-photo-5463581.jpeg",
    bio: "Sertifikalı profesyonel ekip"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    icon: "Award",
    title: "20+ Yıllık Deneyim",
    description: "İklimlendirme sektöründe uzun yıllara dayanan deneyimimiz"
  },
  {
    id: 2,
    icon: "Shield",
    title: "Garanti ve Güvence",
    description: "Tüm işlerimizde garanti belgesi ve kalite güvencesi"
  },
  {
    id: 3,
    icon: "Leaf",
    title: "Çevre Dostu",
    description: "Enerji tasarruflu ve çevre dostu sistemler"
  },
  {
    id: 4,
    icon: "Clock",
    title: "7/24 Hizmet",
    description: "Acil durumlarda kesintisiz teknik destek"
  }
];

export const faqData = [
  {
    id: 1,
    question: "Klimamın bakımını ne sıklıkla yaptırmalıyım?",
    answer: "Klimanızın verimli çalışması için yılda en az 2 kez (yaz ve kış öncesi) profesyonel bakım yaptırmanızı öneririz."
  },
  {
    id: 2,
    question: "VRF sistemi nedir?",
    answer: "VRF (Variable Refrigerant Flow), tek dış ünite ile birden fazla iç ünitenin bağımsız kontrolünü sağlayan, enerji verimliliği yüksek bir iklimlendirme sistemidir."
  },
  {
    id: 3,
    question: "Montaj süresi ne kadar sürer?",
    answer: "Standart split klima montajı ortalama 3-4 saat sürer. VRF sistemleri için süre proje büyüklüğüne göre değişiklik gösterir."
  },
  {
    id: 4,
    question: "Hangi markaların yetkili servisiyiz?",
    answer: "Tüm yerli ve ithal klima markalarının satış, montaj ve servis hizmetini sunuyoruz."
  }
];